import { useQuery } from 'react-query';
import request from '../../../helpers/request';
import queries from './queries';

const getCountries = async () => {
  const data = await request.get(
    `/RentPlace/country`,
    {},
    'При загрузке контрагентов произошла ошибка',
    []
  );
  return data.sort((a, b) => a.orderNum - b.orderNum);
};

const useCountries = () =>
  useQuery([queries.countries], () => getCountries(), {
    placeholderData: [],
  });

export default useCountries;
